function initReviews() {
  document.querySelectorAll('script[data-tt-review-src]').forEach(marker => {
    if (marker.dataset.observed) return;
    marker.dataset.observed = 'true';
    const section = marker.closest('.shopify-section') || marker.parentElement;
    const load = () => {
      if (marker.dataset.loaded) return;
      marker.dataset.loaded = 'true';
      const script = document.createElement('script');
      script.src = marker.dataset.ttReviewSrc;
      script.async = true;
      marker.after(script);
    };
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) { load(); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
    }, { rootMargin: '600px' });
    observer.observe(section);
  });
}
initReviews();
document.addEventListener('shopify:section:load', initReviews);
